import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import { Select, SegmentedControl } from 'localmed-core';

import Form, { Field } from '../../legacyCore/Form';
import { PATIENT_STATUS } from '../../shared/constants';

import style from './WidgetForm.scss';

function nameAsLabel(item) {
  return item ? item.name : '';
}

const WidgetForm = ({
  reasonForVisit,
  reasonForVisitItems,
  selectedPatientStatus,
  noOnlineSchedulingForStatus,
  onChangePatientStatus,
  onChangeReasonForVisit,
}) => {
  const patientStatusItems = [
    { id: PATIENT_STATUS.NEW, display: 'New Patient' },
    { id: PATIENT_STATUS.RETURNING, display: 'Returning Patient' },
  ];
  const selectDisabled =
    reasonForVisitItems == null || reasonForVisitItems.length === 0 || noOnlineSchedulingForStatus;
  const hasPreviousSelected =
    reasonForVisit && selectedPatientStatus.id !== reasonForVisit.patientStatus;

  reasonForVisitItems = sortBy(reasonForVisitItems, 'name');
  return (
    <Form className={style['widget-form']}>
      <div className={style['widget-form-row']}>
        <Field
          name="patientStatus"
          label="Have you visited us before?"
          className={style['widget-form__field']}
        >
          <SegmentedControl
            id="patientStatus"
            name="patientStatus"
            items={patientStatusItems}
            selectedItem={selectedPatientStatus}
            onChange={onChangePatientStatus}
          />
        </Field>
        <Field
          name="reasonForVisit"
          htmlFor="reasonForVisit-input"
          label="What can we help you with?"
          className={style['widget-form__field']}
        >
          <Select
            id="reasonForVisit"
            name="reasonForVisit"
            placeholder="Please select…"
            items={reasonForVisitItems}
            selectedItem={!hasPreviousSelected && reasonForVisit}
            onChange={onChangeReasonForVisit}
            requireAction={!selectDisabled && (reasonForVisit == null || hasPreviousSelected)}
            toLabel={nameAsLabel}
            disabled={selectDisabled}
          />
        </Field>
      </div>
    </Form>
  );
};

WidgetForm.propTypes = {
  patientStatus: PropTypes.string,
  reasonForVisit: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    patientStatus: PropTypes.string.isRequired,
  }),
  reasonForVisitItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      patientStatus: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedPatientStatus: PropTypes.shape({
    id: PropTypes.string.isRequired,
    display: PropTypes.string.isRequired,
  }).isRequired,
  noOnlineSchedulingForStatus: PropTypes.bool,
  onChangePatientStatus: PropTypes.func,
  onChangeReasonForVisit: PropTypes.func,
};

export default WidgetForm;
